import React from 'react';
interface HeaderProps {
  onOpenApplication?: () => void;
}
export function Header({
  onOpenApplication
}: HeaderProps) {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10" data-id="element-135">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-136">
        <div className="flex items-center gap-3" data-id="element-137">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1kKZWeaKM44Vz6MBBPVhgv/elite_1.png" alt="Elite Creator Pass" className="h-10 w-10" data-id="element-138" />
          <span className="text-xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-139">
            ELITE CREATOR PASS
          </span>
        </div>
        <button onClick={onOpenApplication} className="px-6 py-2 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-semibold rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300" data-id="element-140">
          Quiero Inscribirme
        </button>
      </div>
    </header>;
}